import { ACTION_TYPES } from '@/actions';
import { judgeHasNextPage, getPagingList } from "@/core/util";

const INIT_STATE = {
  petHomeInfo: {},
  petList: [],
  hasMore: true,
  records: [],
};

export default function petHome(state = INIT_STATE, action) {
  let result = { ...state };
  const { type, payload } = action;
  switch (type) {
    // 携宠游首页
    case ACTION_TYPES.GET_PET_TOPIC_HOME:
      result.petHomeInfo = payload;
      break;
    // 宠物列表
    case ACTION_TYPES.GET_MEM_PET_LIST:
      result.petList = payload;
      break;
    // 获取订单列表(分页)
    case ACTION_TYPES.GET_PET_ORDER_PAGING_LIST:
      result.hasMore = judgeHasNextPage(payload);
      result.records = getPagingList(result.records, payload);
      break;
    default:
      result = state;
  }
  return result;
}
